export default __webpack_public_path__ + "static/media/insta.7f6374ce.svg";